<template>
  <div v-if="loading" class="row" style="background-color: #fff;">
    <div class="col-12">
      <div class="loader">
        <!-- <b-spinner
          variant="primary"
          type="grow"
          :label="`${$t('reports.detractor.loadingLabel')}...`"
        ></b-spinner> -->
        <idx-skeleton-chart type="area" />
      </div>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-12">
      <div class="reports-wrapper" style="margin-top: 16px;">
        <div
          class="card"
          :style="`width: 100%; height: ${
            dataGraph.layout.h * 35
          }px; overflow-x: hidden;`"
        >
          <highcharts :options="chartOptions"></highcharts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  props: ['dataGraph'],

  components: {
    idxSkeletonChart,
  },

  data: () => ({
    loading: true,
    data: {
      totalAnswers: 0,
      totalAnswersAnalyzed: 0,
      positiveQty: 0,
      neutralQty: 0,
      negativeQty: 0,
      score: 0,
      scoreColor: '#c1c1c1',
      positiveKeyWords: [],
      neutralKeyWords: [],
      negativeKeyWords: [],
    },
    chartOptions: {
      chart: {
        type: 'spline',
        height: this.dataGraph ? this.dataGraph.layout.h * 36 : 400,
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [],
        visible: true,
        labels: {},
      },
      yAxis: {
        title: {
          text: '',
        },
        stackLabels: {
          enabled: true,
          fontWeight: 'bold',
        },
        max: 100,
      },
      tooltip: {
        pointFormat:
          '<span style="color:{series.color}">Quantidade</span>: <b>{point.qty}</b> ({point.y}%)<br/>',
      },
      plotOptions: {
        spline: {
          lineWidth: 3,
        },
        column: {
          pointPadding: 0.1,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
          },
        },
        line: {
          dataLabels: {
            enabled: true,
          },
        },
        area: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          groupPadding: 0,
          pointPadding: 0.05,
          borderWidth: 0,
        },
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
      },
      colors: ['#22CD70', '#F3C102', '#E84C3E'],
      series: [
        {
          name: 'Positivo',
          data: [],
        },
        {
          name: 'Neutro',
          data: [],
        },
        {
          name: 'Negativo',
          data: [],
        },
      ],
    },

    indicatorSelected: null,
    indicatorLabels: [],
    indicatorsItems: [],
    currentPage: 1,
    loadingIndicators: false,
  }),

  methods: {
    async getSentmentAnalysisInfo(dataGraph) {
      this.loading = true;

      const response = await api.get('/reports/sentiment-evolution-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: dataGraph.actionId ? dataGraph.actionId._id : null,
          //startDate: '2021-01-01',
          //endDate: '2021-12-31',
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          metric: dataGraph.metric,
          groupId: dataGraph.actionGroupId ? dataGraph.actionGroupId._id : null,
          indicator: dataGraph.indicator ? dataGraph.indicator : null,
          indicatorValue: dataGraph.valueIndicator,
          // indicatorRange: this.indicatorData.range,
           period: dataGraph.period,
           _id: dataGraph._id,
        },
      });

      this.chartOptions.chart.type = dataGraph.graph;

      this.data.totalAnswers = response.data.totalAnswers;
      this.data.totalAnswersAnalyzed = response.data.totalAnswersAnalyzed;

      this.data.positiveQty = response.data.qty.positive;
      this.data.neutralQty = response.data.qty.neutral;
      this.data.negativeQty = response.data.qty.negative;
      this.data.score = response.data.score.total;
      this.data.scoreColor = this.setColor(response.data.score.total);

      this.chartOptions.xAxis.categories = response.data.months;
      this.chartOptions.series[0].data = response.data.qty.positivePerMonth;
      this.chartOptions.series[1].data = response.data.qty.neutralPerMonth;
      this.chartOptions.series[2].data = response.data.qty.negativePerMonth;

      this.loading = false;
    },

    setColor(score) {
      if (score >= 60) {
        return '#22CD70';
      } else if (score >= 0) {
        return '#F3C102';
      }

      return '#E84C3E';
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.getSentmentAnalysisInfo(this.dataGraph);

    EventBus.$on('update-evolution-sentiment', (items) => {
      this.getSentmentAnalysisInfo(items);
    });
  },
};
</script>

<style scoped lang="scss">
.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reports-wrapper {
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: row;
  justify-content: space-between;
}

.card {
  background-color: #fff;
  border-color: #fff;
  margin-top: 18px;

  h1 {
    font-size: 22px;
  }

  .sentiment-area {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}

.page-spacing {
  padding-left: 15px;
  padding-right: 15px;
}

.graphic-card {
  display: flex;
  flex-direction: column;
  padding: 15px 35px;
  border: 1px solid #eee;
  height: 100%;
}

.chart-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.text-color {
  color: #5f6368;
  font-size: 18px;
  fill: #5f6368;
}

.highcharts-background-pie {
  width: 0;
}

.numbers-area {
  max-width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/sentment-analysis/panels/evolution-sentiment.vue